var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgUnparalleledconicon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_2079",
    "data-name": "Group 2079",
    transform: "translate(-1243 -1362)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_10",
    "data-name": "Ellipse 10",
    cx: 30,
    cy: 30,
    r: 30,
    transform: "translate(1243 1362)",
    fill: "#7dbaab"
  }), /*#__PURE__*/React.createElement("path", {
    id: "connectivity",
    d: "M36.2,25.661a3.457,3.457,0,0,0-2.263.856L27.4,22.826a7.961,7.961,0,0,0-1.456-8.31l6.6-7.7a3.458,3.458,0,0,0,1.252.242A3.493,3.493,0,0,0,37.29,3.566a3.489,3.489,0,1,0-6.977,0,3.449,3.449,0,0,0,.476,1.727l-6.595,7.7a7.942,7.942,0,0,0-7.833-.468L13.328,7.972a3.456,3.456,0,0,0,.7-2.08,3.543,3.543,0,1,0-2.638,3.372l3.035,4.553a7.854,7.854,0,0,0-2.416,8.123L6.042,24.465a3.476,3.476,0,1,0,.935,2.359c0-.076-.018-.146-.022-.221l5.971-2.526a8.118,8.118,0,0,0,6.908,3.908l.724,5.145a3.468,3.468,0,1,0,2.3-.345l-.726-5.165a8.114,8.114,0,0,0,4.1-2.785l6.547,3.7a3.485,3.485,0,1,0,3.426-2.87Zm0,0",
    transform: "translate(1253.154 1372.153)",
    fill: "#fafafa"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnparalleledconicon);
export default __webpack_public_path__ + "static/media/unparalleledconicon.1643fb4cf579818928fe2299fe48901f.svg";
export { ForwardRef as ReactComponent };